const pathReplacer = (pathname, params) => pathname.replace(
  /\[([a-zA-Z]+)\]/g,
  (_, $1) => params[$1],
)

export default pathReplacer
